// extracted by mini-css-extract-plugin
export default {"container":"Analyze_container__cxGZs","title":"Analyze_title__fewh6","left":"Analyze_left__rlcyS","content":"Analyze_content__jVaTU"};